import axios from 'axios';
import logger from '../utils/logger';

// Tentukan baseURL otomatis berdasarkan hostname
const hostname = window.location.hostname;
let API_BASE_URL;

// if (hostname === "localhost") {
//   API_BASE_URL = "http://localhost:3001/api";
// } else if (/^192\.168\./.test(hostname)) {
//   API_BASE_URL = "http://192.168.1.15:3001/api"; // LAN
// } else if (hostname === "staging.sadartalaud.talaudkab.go.id") {
//   API_BASE_URL = "http://192.168.1.50:3001/api"; // staging
// } else {
  API_BASE_URL = "https://api-sadartalaud.talaudkab.go.id/api"; // production
// }

// Fallback kalau nggak ketemu
API_BASE_URL = process.env.REACT_APP_API_URL || API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log API request
    logger.logAPI(config.method?.toUpperCase(), config.url, config.data);
    
    return config;
  },
  (error) => {
    logger.error('API_REQUEST_ERROR', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    // Log successful API response
    logger.logAPI(response.config.method?.toUpperCase(), response.config.url, null, {
      status: response.status,
      data: response.data
    });
    return response;
  },
  (error) => {
    // Log API error
    logger.error('API_RESPONSE_ERROR', {
      method: error.config?.method?.toUpperCase(),
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
      message: error.message
    });
    
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 